import { useRef, useState } from "react";
import type { ChangeEvent, DragEvent } from "react";
import { CLOUDINARY_INTEL_BASE_URL } from "@utils/enum";
import { ACCEPTED_BULK_INPUT_ATTR } from "../constants";

type FileDropzoneProps = {
  onFileSelected: (file: File) => void;
  disabled?: boolean;
};

const FileDropzone = ({ onFileSelected, disabled = false }: FileDropzoneProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (disabled) return;
    setIsDragging(true);
  };

  const handleDragLeave = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragging(false);
    if (disabled) return;
    const file = event.dataTransfer?.files?.[0];
    if (file) onFileSelected(file);
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) onFileSelected(file);
    event.target.value = "";
  };

  return (
    <div onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} className={`tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-2xl tw-border tw-border-dashed tw-px-8 tw-py-8 tw-transition-colors ${isDragging ? "tw-border-primary-purple-600 tw-bg-primary-purple-25" : "tw-border-uploader-border tw-bg-white"} ${disabled ? "tw-opacity-60" : ""}`}>
      <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1789725855/intel/misc/upload_bulk_woppkm.svg`} alt="" className="tw-h-[60px] tw-w-[60px]" />
      <div className="tw-mt-4 tw-text-center">
        <div className="tw-text-lg tw-font-medium tw-text-uploader-title">Drag and drop your files</div>
        <div className="tw-mt-1 tw-text-sm tw-text-uploader-subtitle">only .xls or .csv format accepted</div>
      </div>
      <button type="button" disabled={disabled} onClick={() => inputRef.current?.click()} className="tw-mt-5 tw-h-8 tw-rounded-lg tw-border tw-border-gray-300 tw-bg-white tw-px-3 tw-text-sm tw-font-medium tw-text-gray-900 hover:tw-bg-gray-50 disabled:tw-cursor-not-allowed disabled:tw-opacity-50">
        Select file from system
      </button>
      <input ref={inputRef} type="file" accept={ACCEPTED_BULK_INPUT_ATTR} className="tw-hidden" onChange={handleInputChange} disabled={disabled} />
    </div>
  );
};

export default FileDropzone;
